import type { FC, PropsWithChildren } from "react";

import styles from "./ImageNavLinksList.module.scss";

export const ImageNavLinksList: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.list}>{children}</div>;
};
